import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MfdeliverypriorityDashboard from '../MfdeliverypriorityDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MfdeliverypriorityPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MfdeliverypriorityDashboard />
    )

}